'use strict';

var _baseForm = require('common/components/base-form');

var _baseForm2 = _interopRequireDefault(_baseForm);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _hfReactHelper = require('common/utils/hf-react-helper');

var _hfReactHelper2 = _interopRequireDefault(_hfReactHelper);

var _button = require('common/components/button');

var _button2 = _interopRequireDefault(_button);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var LogInInPerson = _baseForm2['default'].createFormClass({

    propTypes: {
        'guid': _react2['default'].PropTypes.string.isRequired,
        'title': _react2['default'].PropTypes.string.isRequired
    },

    onEmailChange: function onEmailChange(event) {
        this.setState({
            'emailAddress': event.target.value.trim()
        });
    },
    onSubmit: function onSubmit(e) {
        e.preventDefault();

        var emailAddress = $('#email_address').val();

        if (!_hfReactHelper2['default'].isValidEmailAddress(emailAddress)) {
            this.setState({
                'errors': { 'named': { 'email_address': 'Invalid email address' } }
            });
        } else {
            $('#login-form').submit();
        }
    },
    render: function render() {
        var errors = '';
        if (this.state.errors) {
            errors = _react2['default'].createElement(
                'div',
                { className: 'row' },
                _react2['default'].createElement(
                    'div',
                    { className: 'columns small-12 text-center m-login-in-person--errors' },
                    this.renderErrorText()
                )
            );
        }
        return _react2['default'].createElement(
            'div',
            { className: 'm-login-in-person row' },
            _react2['default'].createElement(
                'h4',
                null,
                this.props.title
            ),
            _react2['default'].createElement(
                'div',
                null,
                'To review and sign this document, enter your email address:'
            ),
            _react2['default'].createElement(
                'form',
                { id: 'login-form', className: 'm-login-in-person--form', action: _hfReactHelper2['default'].urlHelper('signer/signInPerson'), method: 'POST' },
                this.renderField('email_address', {
                    'id': 'email_address',
                    'className': '',
                    'maxLength': '99',
                    'placeholder': 'email@example.com',
                    'onChange': this.onEmailChange,
                    'tabIndex': '0',
                    'data-format': 'email'
                }),
                _react2['default'].createElement(
                    'div',
                    { className: 'row' },
                    _react2['default'].createElement(
                        'div',
                        { className: 'columns small-12' },
                        _react2['default'].createElement(_button2['default'], { onClick: this.onSubmit,
                            buttonClass: 'right',
                            buttonText: 'Continue',
                            buttonColor: 'cerulean',
                            buttonHoverColor: 'castle-rock',
                            buttonTabIndex: '1' })
                    )
                ),
                _react2['default'].createElement('input', { type: 'hidden', name: 'short_guid', value: this.props.guid })
            ),
            errors
        );
    }
});

module.exports = LogInInPerson;


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/components/auth/login-in-person.jsx
 ** module id = 886
 ** module chunks = 0
 **/